import { map, pipe, prop, sortBy, toLower } from "ramda";
import { useMemo } from "react";
import { defineMessages, useIntl } from "react-intl";
import { useMsg } from "../../components/Msg/Msg";
import { generalMessages } from "../../components/messages";
import { OTHER_VALUE } from "./CoachProfile/CoachProfileSettings";

const messages = defineMessages({
  "dict.fields.business.label": {
    id: "dict.fields.business.label",
    defaultMessage: "Business",
  },
  "dict.fields.career.label": {
    id: "dict.fields.career.label",
    defaultMessage: "Career",
  },
  "dict.fields.change.label": {
    id: "dict.fields.change.label",
    defaultMessage: "Change",
  },
  "dict.fields.communication.label": {
    id: "dict.fields.communication.label",
    defaultMessage: "Communication",
  },
  "dict.fields.confidence.label": {
    id: "dict.fields.confidence.label",
    defaultMessage: "Confidence",
  },
  "dict.fields.conflict.label": {
    id: "dict.fields.conflict.label",
    defaultMessage: "Conflict",
  },
  "dict.fields.diversity.label": {
    id: "dict.fields.diversity.label",
    defaultMessage: "Diversity",
  },
  "dict.fields.entrepreneurship.label": {
    id: "dict.fields.entrepreneurship.label",
    defaultMessage: "Entrepreneurship",
  },
  "dict.fields.executive.label": {
    id: "dict.fields.executive.label",
    defaultMessage: "Executive",
  },
  "dict.fields.facilitation.label": {
    id: "dict.fields.facilitation.label",
    defaultMessage: "Facilitation",
  },
  "dict.fields.fitness.label": {
    id: "dict.fields.fitness.label",
    defaultMessage: "Fitness",
  },
  "dict.fields.health.label": {
    id: "dict.fields.health.label",
    defaultMessage: "Health",
  },
  "dict.fields.leadership.label": {
    id: "dict.fields.leadership.label",
    defaultMessage: "Leadership",
  },
  "dict.fields.life.label": {
    id: "dict.fields.life.label",
    defaultMessage: "Life",
  },
  "dict.fields.management.label": {
    id: "dict.fields.management.label",
    defaultMessage: "Management",
  },
  "dict.fields.mental_fitness.label": {
    id: "dict.fields.mental_fitness.label",
    defaultMessage: "Mental fitness",
  },
  "dict.fields.mentorship.label": {
    id: "dict.fields.mentorship.label",
    defaultMessage: "Mentorship",
  },
  "dict.fields.negotiations.label": {
    id: "dict.fields.negotiations.label",
    defaultMessage: "Negotiations",
  },
  "dict.fields.organizational_development.label": {
    id: "dict.fields.organizational_development.label",
    defaultMessage: "Organizational Development",
  },
  "dict.fields.performance.label": {
    id: "dict.fields.performance.label",
    defaultMessage: "Performance",
  },
  "dict.fields.relationships.label": {
    id: "dict.fields.relationships.label",
    defaultMessage: "Relationships",
  },
  "dict.fields.sales.label": {
    id: "dict.fields.sales.label",
    defaultMessage: "Sales",
  },
  "dict.fields.teams.label": {
    id: "dict.fields.teams.label",
    defaultMessage: "Teams",
  },
  "dict.fields.time_management.label": {
    id: "dict.fields.time_management.label",
    defaultMessage: "Time Management",
  },
  "dict.fields.transformations.label": {
    id: "dict.fields.transformations.label",
    defaultMessage: "Transformations",
  },
  "dict.fields.wellbeing.label": {
    id: "dict.fields.wellbeing.label",
    defaultMessage: "Wellbeing",
  },
  "dict.fields.women.label": {
    id: "dict.fields.women.label",
    defaultMessage: "Women",
  },

  "dict.fields.product_development.label": {
    id: "dict.fields.product_development.label",
    defaultMessage: "Product Development",
  },
  "dict.fields.product_design.label": {
    id: "dict.fields.product_design.label",
    defaultMessage: "Product Design",
  },
  "dict.fields.it_engineering.label": {
    id: "dict.fields.it_engineering.label",
    defaultMessage: "IT Engineering",
  },
  "dict.fields.human_resources.label": {
    id: "dict.fields.human_resources.label",
    defaultMessage: "People (HR)",
  },
  "dict.fields.finance.label": {
    id: "dict.fields.finance.label",
    defaultMessage: "Finance",
  },
  "dict.fields.compliance.label": {
    id: "dict.fields.compliance.label",
    defaultMessage: "Compliance",
  },
  "dict.fields.legal.label": {
    id: "dict.fields.legal.label",
    defaultMessage: "Legal",
  },

  "dict.fields.ai_adoption_for_leaders.label": {
    id: "dict.fields.ai_adoption_for_leaders.label",
    defaultMessage: "AI Adoption for Leaders",
  },
  "dict.fields.ai_governance_and_ethics.label": {
    id: "dict.fields.ai_governance_and_ethics.label",
    defaultMessage: "AI Governance & Ethics",
  },
  "dict.fields.coaching_skills_for_managers.label": {
    id: "dict.fields.coaching_skills_for_managers.label",
    defaultMessage: "Coaching Skills for Managers",
  },
  "dict.fields.cross_cultural_leadership.label": {
    id: "dict.fields.cross_cultural_leadership.label",
    defaultMessage: "Cross-Cultural Leadership",
  },
  "dict.fields.cultural_differences.label": {
    id: "dict.fields.cultural_differences.label",
    defaultMessage: "Cultural Differences",
  },
  "dict.fields.decision_making.label": {
    id: "dict.fields.decision_making.label",
    defaultMessage: "Decision Making",
  },
  "dict.fields.delegation.label": {
    id: "dict.fields.delegation.label",
    defaultMessage: "Delegation",
  },
  "dict.fields.emotional_intelligence.label": {
    id: "dict.fields.emotional_intelligence.label",
    defaultMessage: "Emotional Intelligence",
  },
  "dict.fields.feedback_culture.label": {
    id: "dict.fields.feedback_culture.label",
    defaultMessage: "Feedback Culture",
  },
  "dict.fields.imposter_syndrome.label": {
    id: "dict.fields.imposter_syndrome.label",
    defaultMessage: "Imposter Syndrome",
  },
  "dict.fields.influencing_skills.label": {
    id: "dict.fields.influencing_skills.label",
    defaultMessage: "Influencing Skills",
  },
  "dict.fields.innovation_and_creativity.label": {
    id: "dict.fields.innovation_and_creativity.label",
    defaultMessage: "Innovation & Creativity",
  },
  "dict.fields.leading_without_authority.label": {
    id: "dict.fields.leading_without_authority.label",
    defaultMessage: "Leading Without Authority",
  },
  "dict.fields.marketing.label": {
    id: "dict.fields.marketing.label",
    defaultMessage: "Marketing",
  },
  "dict.fields.psychological_safety.label": {
    id: "dict.fields.psychological_safety.label",
    defaultMessage: "Psychological Safety",
  },
  "dict.fields.remote_leadership.label": {
    id: "dict.fields.remote_leadership.label",
    defaultMessage: "Remote Leadership",
  },
  "dict.fields.resilience.label": {
    id: "dict.fields.resilience.label",
    defaultMessage: "Resilience",
  },
  "dict.fields.self_criticism.label": {
    id: "dict.fields.self_criticism.label",
    defaultMessage: "Self-criticism",
  },
  "dict.fields.self_leadership.label": {
    id: "dict.fields.self_leadership.label",
    defaultMessage: "Self-Leadership",
  },
  "dict.fields.strategic_thinking.label": {
    id: "dict.fields.strategic_thinking.label",
    defaultMessage: "Strategic Thinking",
  },
  "dict.fields.stress_management.label": {
    id: "dict.fields.stress_management.label",
    defaultMessage: "Stress Management",
  },
});

const translateField = (intl, value) => {
  const getId = (prop) => `dict.fields.${value}.${prop}`;

  return {
    value,
    label: intl.formatMessage({ ...messages[getId("label")] }),
  };
};

const fieldsKeys = [
  "business",
  "career",
  "change",
  "communication",
  "confidence",
  "conflict",
  "diversity",
  "entrepreneurship",
  "executive",
  "facilitation",
  "fitness",
  "health",
  "leadership",
  "life",
  "management",
  "mental_fitness",
  "mentorship",
  "negotiations",
  "organizational_development",
  "performance",
  "relationships",
  "sales",
  "teams",
  "time_management",
  "transformations",
  "wellbeing",
  "women",

  "product_development",
  "product_design",
  "it_engineering",
  "human_resources",
  "finance",
  "compliance",
  "legal",

  "ai_adoption_for_leaders",
  "ai_governance_and_ethics",
  "coaching_skills_for_managers",
  "cross_cultural_leadership",
  "cultural_differences",
  "decision_making",
  "delegation",
  "emotional_intelligence",
  "feedback_culture",
  "imposter_syndrome",
  "influencing_skills",
  "innovation_and_creativity",
  "leading_without_authority",
  "marketing",
  "psychological_safety",
  "remote_leadership",
  "resilience",
  "self_criticism",
  "self_leadership",
  "strategic_thinking",
  "stress_management",
];

const sortByPropCaseInsensitive = (propName) =>
  sortBy(pipe(prop(propName), toLower));

export const useFieldsDict = ({ withOther } = {}) => {
  const generalMsg = useMsg({ dict: generalMessages });
  const intl = useIntl();
  const fieldsOptions = useMemo(
    () =>
      pipe(
        map((k) => translateField(intl, k)),
        sortByPropCaseInsensitive("label"),
        (options) =>
          !withOther
            ? options
            : [
                ...options,
                { value: OTHER_VALUE, label: generalMsg("general.other") }, // TODO: coach filter
              ],
      )(fieldsKeys),
    [generalMsg, intl, withOther],
  );

  return useMemo(() => ({ fieldsOptions }), [fieldsOptions]);
};
